import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars, faHeart, faCalendarAlt, faPlayCircle,
  faChevronDown, faClock, faMapMarkerAlt, faArrowRight,
  faArrowUp, faPhoneAlt, faEnvelope, faUser,
  faUsers, faBolt, faStar, faQuoteLeft,
  faArrowUpRightFromSquare, faPhone, faGlobe, faChildReaching,
  faHandHoldingHeart, faPeopleGroup, faBoxOpen,
  faChevronRight, faChevronLeft, faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram, faYoutube, faWhatsapp, faApple, faGooglePlay } from '@fortawesome/free-brands-svg-icons';

library.add(
  faBars, faHeart, faCalendarAlt, faPlayCircle,
  faChevronDown, faClock, faMapMarkerAlt, faArrowRight,
  faArrowUp, faPhoneAlt, faEnvelope, faUser,
  faUsers, faBolt, faStar, faQuoteLeft,
  faArrowUpRightFromSquare, faPhone, faGlobe, faChildReaching,
  faHandHoldingHeart, faPeopleGroup, faBoxOpen,
  faChevronRight, faChevronLeft, faTimes,
  faFacebookF, faInstagram, faYoutube, faWhatsapp, faApple, faGooglePlay
);
